import React, { useState, useEffect, useLayoutEffect } from "react";
import { Link } from "react-router-dom";
import { useSidebar } from "../context/useSidebar";
import { MenuItem, Sidebar as ReactSidebarPro, SubMenu, Menu } from "react-pro-sidebar";
import styled from "styled-components";

const StyledSidebar = styled(ReactSidebarPro)`
  position: fixed;
  height: 100vh;
  z-index: 99;
  padding: 0 0.7rem;
  top: 5rem;
  background: linear-gradient(to top right, #ffc107 30%, #f26daf 50%, #ffb6c1 70%);

  @media (max-width: 768px) {
    padding: 0;
  }
`;

const StyledSubMenu = styled(SubMenu)`
  &.active-sidebar-subMenu {
    background: var(--primary);
    border-radius: 0.5rem;
    color: black;

    &:hover {
      color: black !important;
    }

    > a {
      background: transparent !important;
      > .ps-menu-label {
        font-weight: 500;
        font-size: 15px;
      }
    }

    > .ps-menu-button {
      > span {
        color: black !important;
      }

      &:hover {
        > span {
          color: black !important;
        }
      }
    }
  }

  &.sidebar-subMenu,
  &.collapse-sidebar-subMenu {
    border-radius: 0.5rem;
    margin: 5px 0;

    > .ps-menu-button {
      background: transparent !important;
    }

    > a {
      color: #b3b3b3;

      &:hover {
        color: darkgrey;
      }
      > .ps-menu-label {
        font-weight: 500;
        font-size: 15px;
      }
    }
  }

  &.collapse-sidebar-subMenu {
    padding: 8px 0;

    > a > .ps-submenu-expand-icon {
      display: none;
    }

    > .ps-menu-button:hover {
      background: #163a4e1a !important;
    }
  }

  &.active-collapse-sidebar-subMenu {
    padding: 8px 0;
    background: rgba(1, 163, 255, 0.1);
    border-radius: 0.5rem;
    color: black;

    > .ps-menu-button,
    > .ps-menu-button:hover {
      background: #163a4e1a !important;
    }

    > a > .ps-submenu-expand-icon {
      display: none;
    }
  }
`;

const StyledMenuItem = styled(MenuItem)`
  &.sidebar-subMenu-item {
    .sidebar-subMenu-item-text {
      transition: all 0.1s;
    }

    > a {
      color: #b3b3b3;
      transition: all 0s;

      &:hover {
        color: darkgrey;
        padding-left: ${({ isSidebarOpen }) => (isSidebarOpen ? "43px" : "23px")};
        color: #01a3ff;
      }
    }

    &:hover {
      background: transparent;

      .sidebar-subMenu-item-text {
      }
    }

    > .ps-menu-button,
    > .ps-menu-button:hover {
      background: #18191f;
    }
  }
`;

export default function Sidebar() {
  const { isSidebarOpen, setIsSidebarOpen } = useSidebar();
  const [openItemIndex, setOpenItemIndex] = useState(null);
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);

  const handleOpenSubMenu = (index) => {
    setOpenItemIndex(openItemIndex === index ? null : index);
  };
  function useWindowSize() {
    const [size, setSize] = useState([0, 0]);
    useLayoutEffect(() => {
      function updateSize() {
        setSize([window.innerWidth, window.innerHeight]);
      }
      window.addEventListener("resize", updateSize);
      updateSize();
      return () => window.removeEventListener("resize", updateSize);
    }, []);
    return size;
  }

  const [width, height] = useWindowSize();
  useEffect(() => {
    setScreenWidth(width);
  }, [width]);

  const sidebarMenu = (
    <Menu>
      {menuItems.map((item, index) => (
        <StyledSubMenu
          onClick={() => handleOpenSubMenu(index)}
          key={item.label}
          className={`${isSidebarOpen ? (openItemIndex === index ? "active-sidebar-subMenu" : "sidebar-subMenu") : openItemIndex === index ? "active-collapse-sidebar-subMenu" : "collapse-sidebar-subMenu"}`}
          label={item.label}
          icon={item.icon}
        >
          {item.subItems.map((subItem) => {
            if (subItem.external) {
              return (
                <a className="sidebar-subMenu-item-text" target="_blank" rel="noreferrer" href={subItem.link}>
                  <StyledMenuItem key={subItem.label} className="sidebar-subMenu-item" isSidebarOpen={isSidebarOpen}>
                    {subItem.label}
                  </StyledMenuItem>
                </a>
              );
            } else {
              return (
                <Link className="sidebar-subMenu-item-text" to={subItem.link}>
                  <StyledMenuItem key={subItem.label} className="sidebar-subMenu-item" isSidebarOpen={isSidebarOpen}>
                    {subItem.label}
                  </StyledMenuItem>
                </Link>
              );
            }
          })}
        </StyledSubMenu>
      ))}
    </Menu>
  );
  const radialGradientBackground = `linear-gradient(to top right, #ffc107 0%, #ffffcc 60%, #ffb6c1 100%)`;

  // const radialGradientBackground = "linear-gradient(95deg, #f69d71 0%, #f26daf 100%)";

  return (
    <>
      {screenWidth < 768 ? (
        <StyledSidebar onBackdropClick={() => setIsSidebarOpen(false)} toggled={isSidebarOpen} breakPoint="always" backgroundColor="#18191f" style={{ marginTop: "5rem" }}>
          {sidebarMenu}
        </StyledSidebar>
      ) : (
        <StyledSidebar collapsed={!isSidebarOpen} collapsedWidth="6rem" width="16.5rem" style={{ width: isSidebarOpen ? "16.5rem" : "6rem", position: "fixed" }}>
          {sidebarMenu}
        </StyledSidebar>
      )}
    </>
  );
}

// Define menu items
const menuItems = [
  {
    label: "Dashboard",
    icon: <i className="material-icons">dashboard</i>,
    subItems: [
      { label: "Dashboard", link: "/", external: false },
      { label: "Rewards", link: "/account", external: false },
    ],
  },
  {
    label: "Transactions",
    icon: <i className="material-icons">book</i>,
    subItems: [{ label: "Recent Transactions", link: "/transactions", external: false }],
  },
  // {
  //   label: "Staking",
  //   icon: <i class="material-icons">forum</i>,
  //   subItems: [{ label: "Staking", link: "/staking", external: false }],
  // },
  {
    label: "Bunswap",
    icon: <i className="material-icons">search</i>,
    subItems: [
      { label: "Website", link: "https://findtoken.xyz/", external: true },
      { label: "Bunswap", link: "/bunswap", external: false },
    ],
  },
  {
    label: "Pages",
    icon: <i className="material-icons">article</i>,
    subItems: [
      { label: "Website", link: "https://findtoken.xyz/", external: true },
      { label: "WhitePaper", link: "https://findtoken.xyz/", external: true },
    ],
  },
];
